import { mount } from '@vue/test-utils';
import SauApiroResponse from './SauApiroResponse.vue';


describe ('Sau Apiro Response', () => {

    let wrapper;

    it('It initially sets the image to be apiro-msg if no message type is supplied', () => {
        wrapper = mount(SauApiroResponse);
        expect(wrapper.vm.image).toBe('/img/apiro-msg.gif');
    });

    it('It initially sets the image to be apiro-msg if the prop type is set to message', () => {
        wrapper = mount(SauApiroResponse, {
            propsData: {
                type: 'message',
            },
            slots: {
                message: 'test message 123'
            }
        });
        expect(wrapper.vm.image).toBe('/img/apiro-msg.gif');
        expect(wrapper.html()).toContain('test message 123');
    });

    it('It sets the image to be apiro-broken if the message type prop is set to error', () => {
        wrapper = mount(SauApiroResponse, {
            propsData: {
                type: 'error',
            }
        });
        expect(wrapper.vm.image).toBe('/img/apiro-broken.gif');
    });

});
